<template>
  <div class="banner" v-if="getFirst">
    <router-link :to="getFirst.value.imgurl">
      <img :src="getFirst.value.imgfile" />
    </router-link>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  name: "HomeBanner",

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      getFirst: "home/getFirst"
    })
  }
};
</script>

<style lang="less" scoped>
.banner {
  // height: 523px;
  color: @color-font-white;
  letter-spacing: 0;
  display: flex;
  justify-content: center;
  a {
    width: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  /*background-image: url("../../../assets/images/banner.png");*/
  /*background-size: 100% 100%;*/
  /*background-repeat: no-repeat;*/
  .banner-contetn {
    /*padding-top: 156px;*/
    width: 1200px;
    .title {
      margin-bottom: 38px;
      font-size: 48px;
      line-height: 48px;
    }
    .effect {
      font-size: 28px;
      letter-spacing: 0;
      line-height: 28px;
      margin-bottom: 66px;
    }
    .understand {
      background: @color-primary;
      cursor: pointer;
      border-radius: 2px;
      width: 128px;
      height: 32px;
      text-align: center;
      font-size: 16px;
      justify-content: center;
    }
  }
}
</style>
